import { client } from './client';

export const departmentApi = {
  getDepartmentListView: () => client.get('get_department_list_view'),
  getDepartmentInfo: (department_id) => client.get('get_department_info', { params: { department_id } }),
  editDepartmentInfo: (params) => client.post('edit_department_info', params),
  setDepartmentManager: (params) => client.get('set_department_manager', { params }),
  deleteDepartment: (params) => client.get('delete_department', { params }),
  addDepartmentWithExistUser: (params) => client.get('add_department_with_exist_user', { params }),
  addDepartmentWithNewUser: (data) => client.post('add_department_with_new_user', data),
  getDepartmentManagersPermissions: () => client.get('get_department_managers_permissions'),
  setManagerCompanyPermission: (params) => client.get('set_manager_company_permission', { params }),
  getDepartmentEmployeesPermissions: () => client.get('get_department_employees_permissions'),
  setEmployeeCompanyPermission: (params) => client.get('set_employee_company_permission', { params }),
};
